// biome-ignore lint/style/useFilenamingConvention: TanStack Router dynamic route parameter

import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { z } from "zod";
import { ProcessingPage } from "@/app/billing/upgrade/processing/processing";

const searchParamsSchema = z.object({
  originalPlanId: z.string().optional(),
});

const defaultValues = {};

function ProcessingSkeleton() {
  return (
    <div className="flex min-h-full items-center justify-center p-4">
      <Skeleton className="h-[400px] w-full max-w-lg rounded-2xl" />
    </div>
  );
}

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId"
)({
  component: () => (
    <Suspense fallback={<ProcessingSkeleton />}>
      <ProcessingPage />
    </Suspense>
  ),
  validateSearch: searchParamsSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  loader: ({ params }) => ({
    planId: params.planId,
    crumb: "Processing",
  }),
});
